export const GET_ENUMS = 'getEnums';
export const SET_ALL_ENUMS = 'setAllEnums';
export const GET_ENUM_BY_NAME = 'getEnumByName';
